import { render, staticRenderFns } from "./BannersList.vue?vue&type=template&id=af761214&scoped=true&"
import script from "./BannersList.vue?vue&type=script&lang=js&"
export * from "./BannersList.vue?vue&type=script&lang=js&"
import style0 from "./BannersList.vue?vue&type=style&index=0&id=af761214&lang=scss&scoped=true&"
import style1 from "./BannersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af761214",
  null
  
)

export default component.exports